const localization = {
  English: {
    translation: {
      limitedProductStirringText: 'Please consider a yearly professional tank cleaning interval',
      search: 'Search...',
      noOptions: 'No options!',
      strategy: 'Strategy',
      welcomeToEvs: 'Welcome to Omya App',
      signInAsOmyaUser: 'Sign in as Omya User',
      or: 'OR',
      to: 'to',
      from: 'from',
      signInAsDistributor: 'Sign in as Distributor',
      signInWithCredentials: 'Sign in with Credentials',
      continueWithSSO: 'Continue with Single Sign-On (SSO)',
      signinwithMocrosoft: 'Sign in with Microsoft',
      multifactorAuthentication: 'Multi-factor Authentication',
      phoneNumber: 'Phone number',
      scanQr: 'Scan this QR Code in -app to verify device',
      confirmationPhoneCodeMessage: 'We sent an SMS with a confirmation code to the number',
      confirmationEmailCodeMessage: 'We send a message to {{email}} with a confirmation code to change your phone number',
      enterManually: 'Or enter the code manually',
      code: 'Code',
      continue: 'Continue',
      linkExpired: 'The link has expired',
      sendMessageTo: 'Please send a message to',
      toGetLink: 'to get a new login link',
      email: 'Email',
      password: 'Password',
      fieldRequired: 'This field is required',
      signIn: 'Sign in',
      enterPasswordFor: 'Please enter the password',
      for: 'for',
      confirmPassword: 'Confirm Password',
      confirm: 'Confirm',
      passwordDoesNotMatch: 'Password does not match',
      help: 'Help Desk',
      helpQuestion:
        'If you have any questions or suggestions, you can ask them here',
      chooseCategory: 'Choose category',
      category: 'Category',
      message: 'Message',
      typeMessage: 'Type your message here',
      attachFile: 'Attach file',
      sendFeedback: 'Send Feedback',
      messageSucces: 'Your message has been sent successfully',
      success: 'Success',
      goBack: 'Go back',
      bugsErrors: 'Bugs & Errors',
      feedback: 'Feedback',
      prospectMap: 'Prospect Map',
      prospectMapText: 'Locate nearby prospects with ease',
      industryBrief: 'Industry/Application Brief',
      industryBriefText: 'Get quickly a 1 pager an industry/application brief',
      converter: 'Product Converter',
      converterText: 'Find Omya alternatives for your used products',
      feasibility: 'Feasibility Check',
      feasibilityText: 'Feasibility check of prospect\'s operation',
      finder: 'Product Finder',
      finderText: 'Find the closer product',
      croptimizer: 'CrOptimizer',
      croptimizerText: 'Decision making tool for liming recommendation',
      home: 'Home',
      currentProductTitle: 'Current product used by customer',
      selectValue: 'Select value',
      currentAlkali: 'Current Alkali',
      concentration: 'Concentration',
      annualConsumption: 'Annual consumption',
      enterAnnualConsumption: 'Enter annual consumption',
      price: 'Price',
      enterPrice: 'Enter price',
      currentExpenditure: 'Current annual expenditure',
      year: 'year',
      omyaOffered: 'Omya product offered to customer',
      product: 'Product',
      costDelivered: 'Product Cost Delivered',
      comparison: 'Comparison',
      ton: 'ton',
      omyaProduct: 'Omya product name',
      expectedConsumption: 'Expected product consumption',
      productCost: 'Annual product cost',
      savings: 'Raw material savings',
      relativeSavings: 'Relative savings',
      back: 'Back',
      save: 'Save',
      cancel: 'Cancel',
      confirmation: 'Confirmation',
      unsavedChanges:
        'You have unsaved changes. Are you sure you want to close this page?',
      blue: 'Blue',
      blueLight: 'Blue light',
      green: 'Green',
      app: 'App',
      language: 'Language',
      currency: 'Currency',
      adminPanel: 'Admin Panel',
      profile: 'Profile',
      companyName: 'Company name',
      enterCompanyName: 'Enter company name',
      industry: 'Industry',
      industrySubSegment: 'Industry sub-segment',
      applications: 'Applications',
      products: 'Products',
      skipToBrief: 'Skip to Brief',
      calculateIntoBrief: 'Calculate into Brief',
      chooseProspect: 'Choose prospects',
      contact: 'Contact',
      contactNumber: 'Contact number',
      status: 'Status',
      rating: 'Rating',
      edit: 'Edit',
      latitude: 'Latitude',
      longtitude: 'Longtitude',
      board: 'Board',
      supplyPlan: 'Supply Plan',
      synthesis: 'Synthesis',
      download: 'Download',
      currentStatus: 'Current status',
      targetStatus: 'Target status',
      resetData: 'Reset Data',
      addProductFigures: 'Add product figures',
      generateBrief: ' Generate Brief',
      next: 'Next',
      soil: 'Soil',
      crop: 'Crop',
      potentialProductivityGain: 'Potential productivity gain',
      economicProductivityGain: 'Economic gain/productivity',
      fertilization: 'Fertilization',
      productName: 'Product Name',
      cropType: 'Crop Type',
      yieldGain: 'Yield Gain',
      additionalParams: 'Adjustable parameters',
      mineralizationGain: 'Mineralization gain',
      whatIsStrategyFiveYears: 'What is your strategy for the next 5 years?',
      potentialLossesFiveYears:
        'Potential losses over 5 years without pH improving',
      potentialLossesMain:
        'Potential losses over 5 years without pH maintenance',
      total: 'Total',
      cost: 'Cost',
      potentialProfitFiveYears:
        'Potential profits over 5 years with pH improving',
      potentialProfitMain:
        'Potential profits over 5 years with pH maintenance',
      delete: 'Delete',
      deleteText:
        'Are you sure you want to delete this field? It will also be deleted from Supply Plan',
      deleteTextWithoutSupply: 'Are you sure you want to delete this field?',
      farmSupplyPlan: 'Farm Supply Plan',
      farmName: 'Farm name or Contact',
      date: 'Date',
      farm: 'Farm',
      fieldName: 'Field name',
      cropRotationReminder: 'Crop rotation reminder',
      omyaSolutions: 'Omya Solutions',
      area: 'Area',
      dose: 'Dose',
      soilPh: 'Soil pH',
      currentph: 'Current pH',
      limingStatus: 'Liming Status',
      targetph: 'Target pH',
      totalPerField: 'Total per field',
      perCrop: 'per crop',
      roi: 'R.O.I.',
      supplyandcrop: 'Supply Plan & CropRotation',
      supplyDelete: 'From Supply Plan',
      whereWouldYouLikeDelete:
        'Where would you like to delete the data about this field?',
      noFieldsTable: 'No Fields have been added to the Farm Supply Plan yet',
      synthesisTableEmpty:
        'Please add Fileds to Farm Supply Plan first to be able to view aggregated data here.',
      goodReasons: 'Good reasons to lime soils with Omya Solutions',
      doseTooltip:
        'Dose for improving or dose for maintaining during crop rotation (2 to 5 crops).',
      roiTooltip:
        'Potential gains or potential R.O.I. (Return On Investment) are indicative as local soil and climatic conditions can increase or decrease these values.',
      current: 'Current',
      target: 'Target',
      name: 'Name',
      productDescription: 'Product description',
      productFigures: 'Product figures',
      keyAdv: 'Key advantages',
      implementationExample: 'Implementation example',
      donwloadPdf: 'Download pdf',
      addCrop: 'Add crop',
      cropRotation: 'Crop Rotation',
      yield: 'Yield',
      phNolimeapp: 'pH if no lime app.',
      expect: 'Expect',
      yieldGains: 'Yield gains',
      npkFertilizerdecrease: 'NPK fertilizer inputs',
      totalGains: 'Total Gains',
      add: 'Add',
      enterFieldName: 'Enter field name',
      namefieldunique: 'The name of the field should be unique',
      surface: 'Surface',
      phavgAnnualDecrease: 'pH avg. annual decrease',
      soilType: 'Soil type',
      fineDrySoil: 'Depth tilled',
      fieldTotalCropRotation: ' Field total area for crop rotation',
      gains: 'Gains',
      organicMatter: 'Organic Matter',
      om: 'OM',
      npkPrices: 'NPK prices',
      editCrop: 'Edit crop',
      npk: 'NPK',
      monps: 'OM-NPS',
      fieldAddedToSupply: '  This Field has been added to the Supply Plan',
      duplicatedField: 'Duplicate Field',
      deleteField: 'Delete Field',
      addToSupply: 'Add to Supply Plan',
      updateSupply: 'Update in Supply Plan',
      field: 'Field',
      addField: 'Add field',
      twototen: '2 to 10 crops',
      rdtnpks: 'Yield+NPKS',
      systemofUnits: 'System of units',
      productFinder: 'Product Finder',
      filters: 'Filters',
      brand: 'Brand',
      application: 'Application',
      transport: 'Transport',
      particleSize: 'Particle size',
      prodClass: 'Prod. Class',
      solidContent: 'Solid Content',
      ginIndex: 'GIN index',
      packaging: 'Packaging',
      plant: 'Plant',
      plantCity: 'Plant City',
      currentYield: 'Current yield',
      pricePerTon: 'Price per ton',
      npkInput: 'NPK input',
      expectedNpkGains: 'Expected NPK gains',
      npkEffiCurrentPh: 'NPK efficiency / current pH',
      npkEffiTarget: 'NPK efficiency gain / target pH',
      npkEffiGain: 'NPK efficiency gain',
      totalNpkGain: 'Total NPK gain',
      soilPhEvolution: 'Soil pH evolution',
      yieldLosses: 'Yield losses',
      npkLosses: 'NPK losses',
      lossesmonps: 'Losses / OM-NPS',
      soilPhachieved: 'Soil pH achieved',
      npkGains: 'NPK gains',
      gainsmonps: 'Gains / OM-NPS',
      improvementincost: 'Improvement in costs in',
      returnoninvestment: 'Return on Investment',
      returnoninvestmentFor: 'for',
      minimumPossibleValue: 'Minimum possible value',
      maximumPossibleValue: 'Maximum possible value',
      phAvgAnnualDecrease: 'pH avg. annual decrease',
      capIndex: 'CAP Index',
      soilTillage: 'Soil tillage',
      soiltooltip1: '0% = no soil tillage',
      soiltooltip2: '50% = 1 ploughing + 2 soil tillage passes',
      monthYear: 'Months / year',
      atCurrentPh: 'at current pH',
      atTargetPh: 'at target pH',
      fineDryTooltip1:
        'Surface x tillage depth x soil density x % of fine soil (< 2 mm)',
      example: 'Example',
      improvementSoilPh: 'Improvement in soil pH with Omya Solutions',
      maintainingSoilPh: 'Maintaining soil pH with Omya Solutions',
      service: 'Service',
      splitInYear: 'Split in year',
      frequency: 'Frequency',
      carbonateAgronomic: 'Carbonate Agronomic Performance',
      optimum: 'Optimum',
      selected: 'Selected',
      efficiency: 'Efficiency',
      highPotential: 'High potential',
      somePotential: 'Some potential',
      noPotential: 'No potential',
      improving: 'Improving',
      maintanence: 'Maintanence',
      yr: 'yr',
      distributor: 'Distributor',
      surfaceArea: 'Field surface area',
      feasibilityCheck: 'Feasibility Check',
      economic: 'Economic',
      plantSetUp: 'Plant Set-up',
      chemical: 'Chemical',
      technical: 'Technical',
      report: 'Report',
      specify: 'Specify',
      logout: 'Log out',
      deleteAccount: 'Delete an account',
      accountDeletedSuccess: 'Account deleted successfully',
      privacyPolicy: 'Privacy Policy',
      termsOfUse: 'Terms of Use',
      confirmDelete: 'Are you sure that you want to delete your account?',
      productDose: 'Product dose NV (CaO)',
      productCost1: 'Product cost',
      cropYieldGain: 'Crop yield gain',
      nameError: 'Fill in the Field Name from above',
      modify: 'Modify',
      duplicate: 'Duplicate',
      totalLosses: 'Total losses',
      synthesis1:
        'Omya liming loosens the soil, reduces energy costs and tool wear',
      synthesis2:
        'Omya liming stimulates the useful biomass for soil fertility and healthy plants growth',
      synthesis3:
        'Omya liming improves soil water retention and availability for plants',
      synthesis4: 'Omya liming promotes plant health and bio-agents resistance',
      synthesis5: 'Omya liming improves crop productivity and quality',
      synthesis6:
        'Omya liming reduces the environmental footprint while increasing profit',
      applicationSelection: 'Application Selection',
      other: 'Other',
      economicFeasibility: 'Economic feasibility',
      averageInflow: 'Average inflow (m3/d)',
      processSteps: 'Process steps in Customer plant',
      alkaliDosingPoint: 'Alkali dosing point',
      alkaliDosingPointText:
        'If alkali is dosed into line between two tanks choose tank before which dosing takes place',
      dosingPoint: 'Dosing point',
      stirredTank: 'Stirred tank',
      plugFlow: 'In-line',
      yes: 'Yes',
      no: 'No',
      no_1: 'No',
      chemicalFeasibility: 'Chemical feasibility',
      productReactivityCheck: 'Product reactivity check',
      updateProductText: 'To update Product, go back to \'Economic\' step',
      updateConcentrationText:
        'To update Concentration, go back to \'Economic\' step',
      expectedAnnualConsumption: 'Expected annual consumption',
      dosageConcentration: 'Dosage concentration',
      startpH: 'Start pH',
      targetpH: 'Target pH',
      aeration: 'Aeration',
      reactionTime: 'Reaction time',
      reactivityIsSufficient: 'Reactivity is sufficient',
      isSulfate: 'Is sulfate',
      bulk: 'Bulk',
      ibc: 'IBC',
      membrane: 'Membrane',
      peristaltic: 'Peristaltic',
      progressingCavity: 'Progressing Cavity',
      centrifugal: 'Centrifugal',
      lime: 'Lime',
      causticSoda: 'Caustic soda',
      flat: 'flat',
      inclined: 'inclined',
      viaBottom: 'via bottom',
      viaTop: 'via top',
      technicalFeasibility: 'Technical feasibility',
      informationOnCurrentSetup: 'Information on current setup',
      productPackaging: 'Product packaging',
      pumpType: 'Pump type',
      rentalPumpRequired: 'Rental pump required for trial?',
      linesTwenty: 'Lines on suction side ≥ DN20',
      linesFifteen: 'Lines on pressure side > DN15',
      valves: 'Valves/Fittings with flow openings > DN15',
      riskExposure: 'Risk of product exposure < 5°C?',
      productUsedBefore: 'Product used before',
      tankBottom: 'Tank bottom',
      productRecirculation: 'Product recirculation',
      productWithdrawel: 'Product Withdrawal',
      numberOfFtl: 'Number of FTL deliveries',
      timeBetweenDeliveries: 'Time between deliveries (d)',
      years: 'years',
      soilPriceDisable: 'Please enter the Product Price',
      nv: 'NV',
      maintained: 'maintained',
      gain: 'gain',
      forPhIncreasing: 'for a pH increasing from',
      disclaimer: 'Disclaimer',
      disclaimerText:
        'All information in the Tool is provided in good faith, but we make no representations or warranties, express or implied, as to the accuracy, adequacy, validity, reliability, availability or completeness of the information in the Tool. Under no circumstances shall omya be liable for any loss or damage of any kind incurred as a result of the use of the tool or reliance on any information provided in the tool. the use of the tool and reliance on the information is solely at the customer\'s own risk. The Tool including its display is property of Omya, protected by copyright and other intellectual property rights and subject to confidentiality indefinitely. No disclosure, copying or reverse engineering is permitted. The information resulting from the Tool is provided for general information purposes only.',
      warning: 'Warning',
      warningText:
        'The technical and economic results (simulations) of the Tool are produced from the information provided by the user. The information provided by the user is the initial data for the mathematical models in the Tool. The mathematical models in the Tool give an average order of magnitude of the potential technical and economic benefits. The actual results obtained in the field depend on local soil and climatic conditions and the actual practices of the farmer.',
      maintenance: 'Maintenance',
      potatoSegment: 'Potato / Starch',
      noSubSegment: 'No Industry sub-segment',
      metal: 'Metal',
      fiveYearsDisclaimer: 'Table for information purposes only and does not take into account crop rotation.',
      'cookie.consent': 'We use cookies to enhance user experience. By using our website, you agree to our use of cookies.',
      'cookie.learnMore': 'Learn more',
      'cookie.acceptAll': 'Accept all',
      'cookie.onlyNecessary': 'Only necessary',
      'cookie.decline': 'Decline',
      CAPoptimal: 'CAP Optimal',
      advancedMode: 'Expert',
      easyVersion: 'Essentials',
      in: 'in',
    },
  },

  German: {
    translation: {
      limitedProductStirringText: 'Bitte berücksichtigen Sie eine jährliche professionelle Tankreinigung',
      noOptions: 'Keine Optionen!',
      search: 'Suche...',
      strategy: 'Strategy',
      linesTwenty: 'Saugseitige Leitungen ≥ DN20',
      welcomeToEvs: 'Welcome to Omya App',
      signInAsOmyaUser: 'Sign in as Omya User',
      or: 'OR',
      to: 'an',
      from: 'von',
      signInAsDistributor: 'Sign in as Distributor',
      signInWithCredentials: 'Mit Anmeldedaten anmelden',
      continueWithSSO: 'Mit Single Sign-On (SSO) fortfahren',
      signinwithMocrosoft: 'Sign in with Microsoft',
      multifactorAuthentication: 'Multi-factor Authentication',
      phoneNumber: 'Phone number',
      scanQr: 'Scan this QR Code in -app to verify device',
      confirmationPhoneCodeMessage: 'We sent an SMS with a confirmation code to the number',
      confirmationEmailCodeMessage: 'We send a message to {{email}} with a confirmation code to change your phone number',
      enterManually: 'Or enter the code manually',
      code: 'Code',
      continue: 'Continue',
      linkExpired: 'The link has expired',
      sendMessageTo: 'Please send a message to',
      toGetLink: 'to get a new login link',
      email: 'Email',
      password: 'Password',
      fieldRequired: 'This field is required',
      signIn: 'Sign in',
      enterPasswordFor: 'Please enter the password',
      for: 'for',
      confirmPassword: 'Confirm Password',
      confirm: 'Confirm',
      passwordDoesNotMatch: 'Password does not match',
      help: 'Help Desk',
      helpQuestion:
        'If you have any questions or suggestions, you can ask them here',
      chooseCategory: 'Choose category',
      category: 'Category',
      message: 'Message',
      typeMessage: 'Type your message here',
      attachFile: 'Attach file',
      sendFeedback: 'Send Feedback',
      messageSucces: 'Your message has been sent successfully',
      success: 'Success',
      goBack: 'Go back',
      bugsErrors: 'Bugs & Errors',
      feedback: 'Feedback',
      prospectMap: 'Prospect Map',
      prospectMapText: 'Finden Sie mögliche Kunden in Ihrer Umgebung',
      industryBrief: 'Industry/Application Brief',
      industryBriefText:
        'Erstellen Sie eine Zusammenfassung für die Industrieanwendung',
      converter: 'Product Converter',
      converterText:
        'Finden Sie Alternativprodukte von Omya zu Ihren derzeit genutzten Produkten',
      feasibility: 'Feasibility Check',
      feasibilityText:
        'Verifizieren Sie die Durchfürbarkeit für die Industrieanwendung',
      finder: 'Product Finder',
      finderText: 'Finden Sie die nächstgelene Produktionsstätte',
      croptimizer: 'CrOptimizer',
      croptimizerText: 'Entscheidungshilfe zur Kalkempfehlung',
      home: 'Home',
      currentProductTitle: 'Aktuell vom Kunden verwendetes Produkt',
      selectValue: 'Wert auswählen',
      currentAlkali: 'Aktuelles Produkt',
      concentration: 'Konzentration',
      annualConsumption: 'Jahresverbrauch',
      enterAnnualConsumption: 'Jahresverbrauch eingeben',
      price: 'Preis',
      enterPrice: 'Preis eingeben',
      currentExpenditure: 'Aktuelle jährliche Betriebsmittelausgaben',
      year: 'Jahr',
      omyaOffered: 'Dem Kunden angebotenes Omya-Produkt',
      product: 'Produkt',
      costDelivered: 'Produktpreis geliefert',
      comparison: 'Vergleich',
      ton: 'ton',
      omyaProduct: 'Omya-Produkt Name',
      expectedConsumption: 'Erwarteter Produktverbrauch',
      productCost: 'Jährliche Produktkosten',
      savings: 'Rohstoffeinsparungen',
      relativeSavings: 'Relative Einsparungen',
      back: 'Zurück',
      save: 'Speichern',
      cancel: 'Stornieren',
      confirmation: 'Bestätigung',
      unsavedChanges:
        'Sie haben nicht gespeicherte Änderungen. Sind Sie sicher, dass Sie diese Seite schließen möchten?',
      blue: 'Blue',
      blueLight: 'Blue light',
      green: 'Green',
      app: 'App',
      language: 'Language',
      currency: 'Currency',
      adminPanel: 'Admin Panel',
      profile: 'Profile',
      companyName: 'Firmenname',
      enterCompanyName: 'Firmenname eingeben',
      industry: 'Industrie',
      industrySubSegment: 'Spezifische Industrie',
      applications: 'Anwendung',
      products: 'Produkt',
      skipToBrief: 'Zum Bericht springen',
      calculateIntoBrief: 'Zum Bericht hinzufügen',
      chooseProspect: 'Interessenten auswählen',
      contact: 'Kontakt',
      contactNumber: 'Kontaktnummer',
      status: 'Status',
      rating: 'Bewertung',
      edit: 'Bearbeiten',
      latitude: 'Breitengrad',
      longtitude: 'Längengrad',
      board: 'Board',
      supplyPlan: 'Supply Plan',
      synthesis: 'Synthesis',
      download: 'Herunterladen',
      currentStatus: 'Akt. Status',
      targetStatus: 'Ziel-Status',
      resetData: 'Daten zurücksetzen',
      addProductFigures: 'Verbrauchsmengen hinzufügen',
      generateBrief: 'Brief erstellen',
      next: 'Weiter',
      soil: 'Boden',
      crop: 'Kulturpflanzen',
      potentialProductivityGain: 'Potenz. Produktivitätsgewinn',
      economicProductivityGain: 'Wirtschaftl. Gewinn / Produktivität',
      fertilization: 'Düngung',
      productName: 'Name des Produkts',
      cropType: 'Kulturart',
      yieldGain: 'Ertragsgewinne',
      additionalParams: 'Einstellbare Parameter',
      mineralizationGain: 'Mineralisierungsgewinn',
      whatIsStrategyFiveYears: 'Was ist Ihre Strategie der nächsten 5 Jahre?',
      potentialLossesFiveYears:
        'Potenz. Verluste über 5 Jahre ohne pH-Verbesserung',
      potentialLossesMain: 'Potenz. Verluste über 5 Jahre ohne pH-Erhaltung',
      total: 'Total',
      cost: 'Kosten',
      potentialProfitFiveYears:
        'Potenz. Gewinne über 5 Jahre mit pH-Verbesserung',
      potentialProfitMain: 'Potenz. Gewinne über 5 Jahre mit pH-Erhaltung',
      delete: 'Löschen',
      deleteText:
        'Sind Sie sicher, dass Sie dieses Feld löschen möchten? Es wird auch aus dem Supply Plan',
      deleteTextWithoutSupply:
        'Sind Sie sicher, dass Sie dieses Feld löschen möchten?',
      farmSupplyPlan: 'Versorgungsplan des Betriebs',
      farmName: 'Name und Kontakt des Betriebs',
      date: 'Datum',
      farm: 'Bauernhof',
      fieldName: 'Name des Feldes',
      cropRotationReminder: 'Erinnerung an die Fruchtfolge',
      omyaSolutions: 'VKD-Lösungen',
      area: 'Areal',
      dose: 'Dosis',
      soilPh: 'Boden-pH',
      currentph: 'Akt. pH-Wert',
      limingStatus: 'Kalkungs-Status',
      targetph: 'Ziel pH-W.',
      totalPerField: 'Gesamt pro Feld',
      perCrop: 'per crop',
      roi: 'Erlös',
      supplyandcrop: 'Supply Plan & CropRotation',
      supplyDelete: 'Von Supply Plan',
      whereWouldYouLikeDelete:
        'Wo möchten Sie die Daten zu diesem Feld löschen?',
      noFieldsTable:
        'Es wurden noch keine Felder zum Versorgungsplan des Betriebs hinzugefügt',
      synthesisTableEmpty:
        'Bitte fügen Sie zuerst Felder zum Versorgungsplan des Betriebs hinzu, um hier aggregierte Daten anzeigen zu können.',
      goodReasons: 'Gute Gründe, Böden mit VKD-Lösungen zu behandeln',
      doseTooltip:
        'Dosis zur Verbesserung oder Dosis zur Erhaltung während der Fruchtfolge (2 bis 5 Kulturen)',
      roiTooltip:
        'Potenzielle Gewinne oder potenzieller R.O.I. (Return On Investment) sind Richtwerte, da lokale Boden- und Klimabedingungen diese Werte erhöhen oder verringern können.',
      current: 'Akt.',
      target: 'Ziel',
      name: 'Name',
      productDescription: 'Beschreibung',
      productFigures: 'Produktkennzahlen',
      keyAdv: 'Die wichtigsten Vorteile',
      implementationExample: 'Implementierungsbeispiel',
      donwloadPdf: 'PDF herunterladen',
      addCrop: 'Kulturpflanzen hinzufügen',
      cropRotation: 'Crop Rotation',
      yield: 'Ertrag',
      phNolimeapp: 'pH ohne Kalkgabe',
      expect: 'Erwarteter',
      yieldGains: 'Ertragsgewinne',
      npkFertilizerdecrease: 'NPK-Dünger-Einsatz',
      totalGains: 'Gesamtgewinne',
      add: 'Hinzufügen',
      enterFieldName: 'Feldname eingeben',
      namefieldunique: 'Der Name des Feldes sollte eindeutig sein',
      surface: 'Oberfläche',
      phavgAnnualDecrease: 'pH Abnahme/Jahr im Schnitt',
      soilType: 'Bodenart',
      fineDrySoil: 'Arbeitstiefe des Bodens',
      fieldTotalCropRotation: 'Feld Gesamtfläche für Fruchtfolge',
      gains: 'Gewinne',
      organicMatter: 'Organisches Material',
      om: 'OM',
      npkPrices: 'NPK-Preise',
      editCrop: 'Kulturpflanzen bearbeiten',
      npk: 'NPK',
      monps: 'OM-NPS',
      fieldAddedToSupply: 'Dieses Feld wurde dem Supply Plan hinzugefügt',
      duplicatedField: 'Feld duplizieren',
      deleteField: 'Feld löschen',
      addToSupply: 'Zum supply Plan hinzufügen',
      updateSupply: 'Aktualisierung in Supply Plan',
      field: 'Feld',
      addField: 'Feld hinzufügen',
      twototen: '2 bis 10 Kulturen',
      rdtnpks: 'Ertrag+NPKS',
      systemofUnits: 'System of units',
      productFinder: 'Product Finder',
      filters: 'Filter',
      brand: 'Marke',
      application: 'Anwendung',
      transport: 'Transport',
      particleSize: 'Particle size',
      prodClass: 'Prod. Class',
      solidContent: 'Solid Content',
      ginIndex: 'GIN index',
      packaging: 'Verpackung',
      plant: 'Werk',
      plantCity: 'Werkstadt',
      currentYield: 'Aktueller Ertrag',
      pricePerTon: 'Preis pro Tonne',
      npkInput: 'NPK-Einsatz',
      expectedNpkGains: 'Erwarteter NPK-Gewinne',
      npkEffiCurrentPh: 'NPK-Effizienz / akt. pH-Wert',
      npkEffiTarget: 'NPK-Effizienzgewinn / Ziel-pH-W.',
      npkEffiGain: 'NPK-Effizienzgewinn',
      totalNpkGain: 'NPK-Gewinn insgesamt',
      soilPhEvolution: 'PH-Entwicklung',
      yieldLosses: 'Ertragsverluste',
      npkLosses: 'NPK-Verluste',
      lossesmonps: 'Verluste/ OM-NPS',
      soilPhachieved: 'Erzielter pH',
      npkGains: 'NPK-Gewinne',
      gainsmonps: 'Gewinne / OM-NPS',
      improvementincost: 'Verbesserung der Kosten in €/ha/5 Jahre',
      returnoninvestment: 'Investitionsrentabilität',
      returnoninvestmentFor: 'für',
      minimumPossibleValue: 'Minimal möglicher Wert',
      maximumPossibleValue: 'Maximal möglicher Wert',
      phAvgAnnualDecrease: 'pH Abnahme/Jahr im Schnitt',
      capIndex: 'CAP-Index',
      soilTillage: 'Bodenbearb.',
      soiltooltip1: '0% = 0x Bodenbearbeitung',
      soiltooltip2: '50% = 1 x Pflug + 2 Bodenbearb.s',
      monthYear: 'Monate/Jahr',
      atCurrentPh: 'bei Akt. pH-Wert',
      atTargetPh: 'bei Ziel pH-W.',
      fineDryTooltip1:
        'Fläche x Bearbeitungstiefe x Bodendichte x % Feinerde < 2 mm.',
      example: 'Beispiel',
      improvementSoilPh: 'Verbesserung des pH im Boden mit VKD-Lösungen',
      maintainingSoilPh: 'Erhaltung des Boden-pH-Wertes mit VKD-Lösungen',
      service: 'Service',
      splitInYear: 'Jahressplitt',
      frequency: 'Häufigkeit',
      carbonateAgronomic: 'Carbonat Agronomische Leistung',
      optimum: 'Optimale',
      selected: 'Ausgewählt',
      efficiency: 'Wirkungsgrad',
      highPotential: 'Hohes Potenzial',
      somePotential: 'Einiges Potenzial',
      noPotential: 'Kein Potenzial',
      improving: 'Korrektur',
      maintanence: 'Erhaltung',
      yr: 'Jr.',
      distributor: 'Distributor',
      surfaceArea: 'Fläche des Feldes',
      feasibilityCheck: 'Feasibility Check',
      economic: 'Economic',
      plantSetUp: 'Plant Set-up',
      chemical: 'Chemical',
      technical: 'Technical',
      report: 'Report',
      specify: 'Specify',
      logout: 'Log out',
      deleteAccount: 'Delete an account',
      accountDeletedSuccess: 'Account deleted successfully',
      privacyPolicy: 'Privacy Policy',
      termsOfUse: 'Terms of Use',
      confirmDelete: 'Are you sure that you want to delete your account?',
      productDose: 'Produktdosis NV (CaO)',
      productCost1: 'Produktkosten',
      cropYieldGain: 'Ernteertragssteigerung',
      nameError: 'Füllen Sie den Feldnamen von oben aus',
      modify: 'Ändern',
      duplicate: 'Duplizieren',
      totalLosses: 'Gesamtverlust',
      synthesis1:
        'VKD-Kalkung lockert den Boden auf, reduziert Energiekosten und Werkzeugverschleiß',
      synthesis2:
        'VKD-Kalkung stimuliert die nützliche Biomasse für Bodenfruchtbarkeit & Wachstum gesunder Pflanzen',
      synthesis3:
        'VKD-Kalkung verbessert die Wasserrückhaltung im Boden und die Verfügbarkeit für die Pflanzen',
      synthesis4:
        'VKD-Kalkung fördert die Pflanzengesundheit und die Resistenz gegen biologische Wirkstoffe',
      synthesis5:
        'VKD-Kalkung verbessert die Produktivität und Qualität der Ernte',
      synthesis6:
        'VKD-Kalkung reduziert die Umweltbelastung und erhöht den Ertrag',
      years: 'jahrelang',
      nv: 'NV',
      soilPriceDisable: 'Bitte geben Sie den Produktpreis ein',
      maintained: 'Pflegen',
      gain: 'gewinnen',
      forPhIncreasing: 'für einen ansteigenden pH-Wert von',
      disclaimer: 'HAFTUNGSAUSSCHLUSS',
      disclaimerText:
        'Alle Informationen im Tool werden nach bestem Wissen und Gewissen zur Verfügung gestellt,  wir geben keinerlei  Zusicherungen oder Gewährleistungen für Genauigkeit, Angemessenheit, Gültigkeit, Zuverlässigkeit, Verfügbarkeit oder Vollständigkeit der Informationen. Unter keinen umständen haftet omya für verluste oder schäden jeglicher art, die sich aus der nutzung des tools oder dem vertrauen auf dessen informationen ergeben. die nutzung und das vertrauen auf die informationen erfolgt ausschliesslich auf eigenes risiko des kunden.Das Tool einschließlich seiner Darstellung ist Eigentum der Omya, urheberrechtlich und durch andere Rechte am geistigen Eigentum geschützt und unterliegt auf unbestimmte Zeit der Geheimhaltung. Die Weitergabe, das Kopieren oder Reverse Engineering ist nicht gestattet. Die aus dem Tool resultierenden Informationen werden nur zu allgemeinen Informationszwecken bereitgestellt.',
      warning: 'Warnung',
      warningText:
        'Die technischen und wirtschaftlichen Ergebnisse (Simulationen) des Werkzeugs werden auf der Grundlage der vom Benutzer bereitgestellten Informationen erstellt. Die vom Benutzer bereitgestellten Informationen sind die Ausgangsdaten für die mathematischen Modelle im Werkzeug.Die mathematischen Modelle im Werkzeug geben eine durchschnittliche Größenordnung des potenziellen technischen und wirtschaftlichen Nutzens an. Die tatsächlichen Ergebnisse, die auf dem Feld erzielt werden, hängen von den örtlichen Boden- und Klimabedingungen und den tatsächlichen Praktiken der Landwirte ab. ',
      maintenance: 'Erhaltung',
      yes: 'Ja',
      no: 'Keine',
      no_1: 'Nein',
      applicationSelection: 'Anwendungsauswahl',
      other: 'Andere',
      economicFeasibility: 'Wirtschaftliche Machbarkeit',
      averageInflow: 'Durchschnittlicher Zulauf (m³/T)',
      processSteps: 'Prozessschritte im Kundenwerk',
      alkaliDosingPoint: 'Aktuelle Laugendosierstelle',
      alkaliDosingPointText: 'Wenn Alkali in die Leitung zwischen zwei Tanks dosiert wird, wählen Sie den Tank, vor dem die Dosierung erfolgt',
      dosingPoint: 'Dosierpunkt',
      stirredTank: 'Gerührter Tank',
      plugFlow: 'In-line Dosierung',
      chemicalFeasibility: 'Chemische Machbarkeit',
      productReactivityCheck: 'Prüfung der Produktreaktivität',
      updateProductText: 'Um das Produkt zu aktualisieren, kehren Sie zum Schritt "Wirtschaftlich" zurück"',
      updateConcentrationText: 'Um die Konzentration zu aktualisieren, gehen Sie zurück zum Schritt \'Wirtschaftlich\'',
      expectedAnnualConsumption: 'Erwarteter Jahresverbrauch',
      dosageConcentration: 'Dosierungskonzentration',
      startpH: 'pH-Wert starten',
      targetpH: 'Ziel-pH',
      aeration: 'Belüftung',
      reactionTime: 'Reaktionszeit',
      reactivityIsSufficient: 'Reaktivität ist ausreichend',
      isSulfate: 'Ist Sulfat',
      bulk: 'Lose',
      ibc: 'IBC',
      membrane: 'Membran',
      peristaltic: 'Schlauchquetschpumpe',
      progressingCavity: 'Exzenterschneckenpumpe',
      centrifugal: 'Kreiselpumpe',
      lime: 'Lime',
      causticSoda: 'Caustic soda',
      flat: 'Flach',
      inclined: 'Konisch / Konkav',
      viaBottom: 'über unten',
      viaTop: 'über oben',
      technicalFeasibility: 'Technische Machbarkeit',
      informationOnCurrentSetup: 'Informationen zum aktuellen Setup',
      productPackaging: 'Produktverpackung',
      pumpType: 'Pumpentyp',
      rentalPumpRequired: 'Für den Test ist eine Mietpumpe erforderlich',
      linesTwentyFive: 'Saugseitige Leitungen ≥ DN20',
      linesFifteen: 'Leitungen auf der Druckseite > DN15',
      valves: 'Ventile/Armaturen mit Durchflussöffnungen > DN15',
      riskExposure: 'Risiko einer Produktexposition < 5°C',
      productUsedBefore: 'Produkt schon einmal verwendet',
      tankBottom: 'Tankboden',
      productRecirculation: 'Produktrückführung',
      productWithdrawel: 'Produktentnahme',
      numberOfFtl: 'Anzahl der FTL-Lieferungen pro Jahr',
      timeBetweenDeliveries: 'Zeit zwischen Lieferungen (T)',
      potatoSegment: 'Potato / Starch',
      noSubSegment: 'Keine spezifische Industrie',
      metal: 'Metal',
      fiveYearsDisclaimer: 'Die Tabelle dient lediglich der Information und berücksichtigt nicht die Fruchtfolge.',
      'cookie.consent': 'Wir verwenden Cookies, um die Benutzererfahrung zu verbessern. Durch die Nutzung unserer Website stimmen Sie der Verwendung von Cookies zu.',
      'cookie.learnMore': 'Mehr erfahren',
      'cookie.acceptAll': 'Alle akzeptieren',
      'cookie.onlyNecessary': 'Nur notwendig',
      'cookie.decline': 'Ablehnen',
      CAPoptimal: 'Optimales CAP',
      advancedMode: 'Experte',
      easyVersion: 'Basis',
      in: 'in',
    },
  },

  French: {
    translation: {
      limitedProductStirringText: 'Veuillez envisager un nettoyage professionnel annuel du réservoir.',
      noOptions: 'Pas d\'options !',
      search: 'Recherche...',
      strategy: 'Strategy',
      linesTwenty: 'Conduites côté aspiration ≥ DN20',
      welcomeToEvs: 'Welcome to Omya App',
      signInAsOmyaUser: 'Sign in as Omya User',
      or: 'OR',
      to: 'à',
      from: 'de',
      signInAsDistributor: 'Sign in as Distributor',
      signInWithCredentials: 'Se connecter avec les identifiants',
      continueWithSSO: 'Continuer avec Single Sign-On (SSO)',
      signinwithMocrosoft: 'Sign in with Microsoft',
      multifactorAuthentication: 'Multi-factor Authentication',
      phoneNumber: 'Phone number',
      scanQr: 'Scan this QR Code in -app to verify device',
      confirmationPhoneCodeMessage: 'We sent an SMS with a confirmation code to the number',
      confirmationEmailCodeMessage: 'We send a message to {{email}} with a confirmation code to change your phone number',
      enterManually: 'Or enter the code manually',
      code: 'Code',
      continue: 'Continue',
      linkExpired: 'The link has expired',
      sendMessageTo: 'Please send a message to',
      toGetLink: 'to get a new login link',
      email: 'Email',
      password: 'Password',
      fieldRequired: 'This field is required',
      signIn: 'Sign in',
      enterPasswordFor: 'Please enter the password',
      for: 'for',
      confirmPassword: 'Confirm Password',
      confirm: 'Confirm',
      passwordDoesNotMatch: 'Password does not match',
      help: 'Help Desk',
      helpQuestion:
        'If you have any questions or suggestions, you can ask them here',
      chooseCategory: 'Choose category',
      category: 'Category',
      message: 'Message',
      typeMessage: 'Type your message here',
      attachFile: 'Attach file',
      sendFeedback: 'Send Feedback',
      messageSucces: 'Your message has been sent successfully',
      success: 'Success',
      goBack: 'Go back',
      bugsErrors: 'Bugs & Errors',
      feedback: 'Feedback',
      prospectMap: 'Prospect Map',
      prospectMapText: 'Localisez facilement des prospects à proximité',
      industryBrief: 'Industry/Application Brief',
      industryBriefText:
        'Obtenez rapidement une synthèse d\'une page pour une industrie/application',
      converter: 'Product Converter',
      converterText: 'Trouvez le produit le plus proche',
      feasibility: 'Feasibility Check',
      feasibilityText:
        'Vérification de la faisabilité de l\'opération chez le prospect',
      finder: 'Product Finder',
      finderText: 'Trouvez le produit le plus proche',
      croptimizer: 'CrOptimizer',
      croptimizerText:
        'Outil d\'aide à la decision pour recommendation chaulage',
      home: 'Home',
      currentProductTitle: 'Produit utilisé par le client ',
      selectValue: 'Sélectionnez la valeur',
      currentAlkali: 'Produit utilisé',
      concentration: 'Concentration',
      annualConsumption: 'Consommation annuelle',
      enterAnnualConsumption: 'Entrez la consommation annuelle',
      price: 'Prix',
      enterPrice: 'Entrez le prix',
      currentExpenditure: 'Dépenses annuelles',
      year: 'an',
      omyaOffered: 'Produit proposé',
      product: 'Produit',
      costDelivered: 'Coût du produit livré',
      comparison: 'Comparaison',
      ton: 'T',
      omyaProduct: 'Nom du Produit Omya',
      expectedConsumption: 'Consommation prévue du produit',
      productCost: 'Coût annuel du produit',
      savings: 'Économies sur matières premières',
      relativeSavings: 'Économies relatives',
      back: 'Retour',
      save: 'Sauvegarder',
      cancel: 'Annuler',
      confirmation: 'Confirmation',
      unsavedChanges:
        'Vous avez des modifications non enregistrées. Êtes-vous sûr de vouloir fermer cette page?',
      blue: 'Blue',
      blueLight: 'Blue light',
      green: 'Green',
      app: 'App',
      language: 'Language',
      currency: 'Currency',
      adminPanel: 'Admin Panel',
      profile: 'Profile',
      companyName: 'Nom de l\'entreprise',
      enterCompanyName: 'Entrez le nom de l\'entreprise',
      industry: 'Industrie',
      industrySubSegment: 'Sous-catégorie',
      applications: 'Applications',
      products: 'Produit',
      skipToBrief: 'Passer directement au rapport',
      calculateIntoBrief: 'Intégrer comparaison économique dans le brief',
      chooseProspect: 'Choisissez un prospect',
      contact: 'Contact',
      contactNumber: 'Numéro du contact',
      status: 'Statut',
      rating: 'Classement',
      edit: 'Modifier',
      latitude: 'Latitude',
      longtitude: 'Longueur',
      board: 'Board',
      supplyPlan: 'Supply Plan',
      synthesis: 'Synthesis',
      download: 'Télécharger',
      currentStatus: 'Etat actuel',
      targetStatus: 'Etat visé',
      resetData: 'Réinitialiser les Données',
      addProductFigures: 'Estimer les consommations de produit',
      generateBrief: 'Générer un Brief',
      next: 'Suivant',
      soil: 'Sol',
      crop: 'Culture',
      potentialProductivityGain: 'Gain potentiel de productivité',
      economicProductivityGain: 'Gain économique / productivité',
      fertilization: 'Fertilisation',
      productName: 'Nom du Produit',
      cropType: 'Type de culture',
      yieldGain: 'Gain en rendement',
      additionalParams: 'Paramètres ajustables',
      mineralizationGain: 'Gain minéralisation',
      whatIsStrategyFiveYears: 'Quelle stratégie pour les 5 ans à venir?',
      potentialLossesFiveYears:
        'Pertes potentielles sur 5 ans sans chaulage pH',
      potentialLossesMain:
        'Pertes potentielles sur 5 ans sans',
      total: 'Total',
      cost: 'Coût',
      potentialProfitFiveYears:
        'Gains potentiels sur 5 ans si redressement du pH',
      potentialProfitMain: 'Gains potentiels sur 5 ans si entretien du pH',
      delete: 'Supprimer',
      deleteText:
        'Êtes-vous sûr de vouloir supprimer ce champ? Il sera également supprimé de Supply Plan',
      deleteTextWithoutSupply: 'Êtes-vous sûr de vouloir supprimer ce champ?',
      farmSupplyPlan: 'Plan d\'Approvisionnement de l\'Exploitation',
      farmName: 'Nom & Contact de l\'Exploitation',
      date: 'Date',
      farm: 'l\'Exploitation',
      fieldName: 'Nom de parcelle',
      cropRotationReminder: 'Rappel rotation de cultures',
      omyaSolutions: 'Solutions MEAC',
      area: 'Aire',
      dose: 'Dose',
      soilPh: 'pH du sol',
      currentph: 'pH actuel',
      limingStatus: 'Etat Amdt',
      targetph: 'Etat visé',
      totalPerField: 'TOTAL par parcelle',
      perCrop: 'par culture',
      roi: 'R.S.I.',
      supplyandcrop: 'Supply Plan & CropRotation',
      supplyDelete: 'À Partir Du Supply Plan',
      whereWouldYouLikeDelete:
        'Où souhaitez-vous supprimer les données de ce champ?',
      noFieldsTable: 'Aucun champ n\'a encore été ajouté au Farm Supply Plan',
      synthesisTableEmpty:
        'Veuillez d\'abord ajouter des champs à Plan d\'Approvisionnement de l\'Exploitation pour pouvoir afficher les données agrégées ici.',
      goodReasons:
        'Bonnes raisons pour amender les sols avec les solutions MEAC',
      doseTooltip:
        'dose pour redressement ou entretien pendant la rotation des cultures (2 à 5 cultures).',
      roiTooltip:
        'Gains potentiels ou R.S.I. (Retour Sur Investissement) potentiel indicatifs car les conditions pédologiques et climatiques locales peuvent augmenter ou diminuer ces valeurs.',
      current: 'Actuel',
      target: 'Visé',
      name: 'Nom',
      productDescription: 'Description du produit',
      productFigures: 'Chiffres du produit',
      keyAdv: 'Principaux avantages',
      implementationExample: 'Exemple de mise en œuvre',
      donwloadPdf: 'Télécharger le pdf',
      addCrop: 'Ajoutez la culture',
      cropRotation: 'Crop Rotation',
      yield: 'Rdt',
      phNolimeapp: 'pH sans amdt',
      expect: 'Attendu',
      yieldGains: 'Gains Rdt',
      npkFertilizerdecrease: 'Apport engrais NPK',
      totalGains: 'Total Gains',
      add: 'Ajouter',
      enterFieldName: 'Entrez le nom du champ',
      namefieldunique: 'Le nom du champ doit être unique',
      surface: 'Surface',
      phavgAnnualDecrease: 'Baisse annuelle du pH',
      soilType: 'Type de sol',
      fineDrySoil: 'Profondeur de travail du sol',
      fieldTotalCropRotation: 'TOTAL parcelle pour la rotation de cultures',
      gains: 'Gains',
      organicMatter: 'Matière Organique',
      om: 'MO',
      npkPrices: 'Prix NPK',
      editCrop: 'Modifier le culture',
      npk: 'NPK',
      monps: 'OM-NPS',
      fieldAddedToSupply: 'Ce champ a été ajouté à la Supply Plan',
      duplicatedField: 'Champ dupliqué',
      deleteField: 'Supprimer le Champ',
      addToSupply: 'Ajouter à Supply Plan',
      updateSupply: 'Mise à jour dans Supply Plan',
      field: 'Champ',
      addField: 'Ajouter un Champ',
      twototen: '2 à 10 cultures',
      rdtnpks: 'Rdt+NPKS',
      systemofUnits: 'System of units',
      productFinder: 'Product Finder',
      filters: 'Filtres',
      brand: 'Marque',
      application: 'Application',
      transport: 'Transport',
      particleSize: 'Particle size',
      prodClass: 'Prod. Class',
      solidContent: 'Solid Content',
      ginIndex: 'GIN index',
      packaging: 'Emballage',
      plant: 'Usine',
      plantCity: 'Ville de l\'usine',
      currentYield: 'Rendement actuel',
      pricePerTon: 'Prix à la tonne',
      npkInput: 'Apport NPK',
      expectedNpkGains: 'Gains NPK attendus',
      npkEffiCurrentPh: 'Efficacité NPK / pH actuel',
      npkEffiTarget: 'Gain efficacité NPK / pH visé',
      npkEffiGain: 'Total gain efficacité NPK',
      totalNpkGain: 'Total gain efficacité NPK',
      soilPhEvolution: 'Evolution pH du sol',
      yieldLosses: 'Pertes Rdt',
      npkLosses: 'Pertes NPK',
      lossesmonps: 'Pertes / MO-NPS',
      soilPhachieved: 'pH du sol obtenu',
      npkGains: 'Gains NPK',
      gainsmonps: 'Gains / MO-NPS',
      improvementincost: 'Coût du redressement en',
      returnoninvestment: 'Gains totaux',
      returnoninvestmentFor: 'pour',
      minimumPossibleValue: 'Valeur minimale possible',
      maximumPossibleValue: 'Valeur maximale possible',
      phAvgAnnualDecrease: 'Baisse annuelle du pH',
      capIndex: 'Index CAP',
      soilTillage: 'Travail du sol',
      soiltooltip1: '0% = pas de travail du sol',
      soiltooltip2: '50% = 1 labour + 2 passages',
      monthYear: 'Mois / année',
      atCurrentPh: 'à pH actuel',
      atTargetPh: 'à pH visé',
      fineDryTooltip1:
        'Surface x profondeur du travail du sol x densité du sol x % de sol fin < 2 mm.',
      example: 'Exemple',
      improvementSoilPh: 'Redresser le pH du sol',
      maintainingSoilPh: 'Entretenir le pH du sol',
      service: 'Service',
      splitInYear: 'Répartition en année',
      frequency: 'Fréquence',
      carbonateAgronomic: 'Carbonate Agronomic Performance',
      optimum: 'Minimum',
      selected: 'Retenu',
      efficiency: 'Efficacité',
      highPotential: 'Potentiel élevé',
      somePotential: 'Un certain potentiel',
      noPotential: 'Aucun potentiel',
      improving: 'Redress.',
      maintanence: 'Entretien',
      yr: 'an',
      distributor: 'Distributor',
      surfaceArea: 'Surface parcelle',
      feasibilityCheck: 'Feasibility Check',
      economic: 'Economique',
      plantSetUp: 'Installation',
      chemical: 'Chimique',
      technical: 'Technique',
      report: 'Rapport',
      specify: 'Selectionner une valeur',
      logout: 'Log out',
      deleteAccount: 'Delete an account',
      accountDeletedSuccess: 'Account deleted successfully',
      privacyPolicy: 'Privacy Policy',
      termsOfUse: 'Terms of Use',
      confirmDelete: 'Are you sure that you want to delete your account?',
      productDose: 'Dose exprimée en VN (CaO)',
      productCost1: 'Coût du produit',
      cropYieldGain: 'Gain de rendement',
      nameError: 'Remplissez le nom du champ ci-dessus',
      modify: 'Modifier',
      duplicate: 'Dupliquer',
      totalLosses: 'Pertes totales',
      synthesis1:
        'Chauler ameublit le sol, réduit l\'usure des outils et les coûts énergétiques.',
      synthesis2:
        'Chauler stimule la biomasse utile pour la fertilité du sol et la croissance de plantes saines.',
      synthesis3:
        'Chauler augmente la rétention en eau du sol et sa disponibilité pour les plantes.',
      synthesis4:
        'Chauler favorise la santé des plantes et leur résistance aux bioagresseurs.',
      synthesis5:
        'Chauler améliore la productivité et la qualité des récoltes.',
      synthesis6:
        'Chauler réduit l\'empreinte environnementale du sol tout en augmentant la rentabilité.',
      years: 'années',
      nv: 'VN',
      soilPriceDisable: 'Veuillez saisir le Prix du Produit',
      maintained: 'Maintenu',
      gain: 'gain',
      forPhIncreasing: 'pour un pH augmentant de',
      disclaimer: 'CLAUSE DE NON-RESPONSABILITÉ',
      disclaimerText:
        'Toutes les informations contenues dans l\'Outil sont fournies de bonne foi : nous ne faisons aucune déclaration ni ne donnons de garantie, expresse ou implicite, quant à l\'exactitude, l\'adéquation, la validité, la fiabilité, la disponibilité ou l\'exhaustivité des informations contenues dans l\'Outil. Meac ne pourra pas être tenu responsable de toute perte ou de tout dommage de quelque nature que ce soit résultant de l\'utilisation de l\'outil ou de la confiance accordée à toute information fournie dans l\'outil. L\'utilisation de l\'outil et des informations se font aux risques et périls du client. L\'outil, y compris son affichage, propriété de MEAC, protégé par le droit d\'auteur et d\'autres droits de propriété intellectuelle et soumis à la confidentialité pour une durée indéterminée. Aucune divulgation, copie ou ingénierie inverse n\'est autorisée. Les informations résultant de l\'outil sont fournies à titre d\'information générale uniquement.',
      warning: 'AVERTISSEMENT',
      warningText:
        'Les résultats techniques et économiques (simulations) de l\'outil sont obtenus à partir des informations fournies par l\'utilisateur. Les informations fournies par l\'utilisateur constituent les données initiales des modèles mathématiques de l\'outil. Les modèles mathématiques de l\'outil donnent un ordre de grandeur moyen des avantages techniques et économiques potentiels. Les résultats réels obtenus sur le terrain dépendent des conditions pédoclimatiques locales et des pratiques réelles de l’agriculteur.',
      maintenance: 'Entretien',
      yes: 'Oui',
      no: 'Pas',
      no_1: 'Non',
      applicationSelection: 'Application Selection',
      other: 'Autres',
      economicFeasibility: 'Faisabilité Économique',
      averageInflow: 'Débit moyen (m³/jour)',
      processSteps: 'Étapes du processus dans l\'usine du client',
      alkaliDosingPoint: 'Point de dosage du produit actuel*',
      alkaliDosingPointText: 'Si le produit est dosé en ligne entre deux réservoirs, choisissez le réservoir avant lequel le dosage a lieu',
      dosingPoint: 'Point de dosage',
      stirredTank: 'Cuve agitée',
      plugFlow: 'Dosage en ligne',
      chemicalFeasibility: 'Faisabilité Chimique',
      productReactivityCheck: 'Contrôle de la réactivité du produit',
      updateProductText: 'Pour mettre à jour le produit, revenez à l\'étape "Économique"',
      updateConcentrationText: 'Pour mettre à jour la concentration, revenez à l\'étape "Économique"',
      expectedAnnualConsumption: 'Consommation annuelle prévue',
      dosageConcentration: 'Concentration de dosage',
      startpH: 'pH de depart',
      targetpH: 'pH cible',
      aeration: 'Aération',
      reactionTime: 'Temps de réaction',
      reactivityIsSufficient: 'La réactivité est suffisante',
      isSulfate: 'Is sulfate',
      bulk: 'Vrac',
      ibc: 'IBC',
      membrane: 'Membrane',
      peristaltic: 'Peristaltique',
      progressingCavity: 'Cavité progressive',
      centrifugal: 'Centrifuge',
      lime: 'Lime',
      causticSoda: 'Caustic soda',
      flat: 'Plat',
      inclined: 'incliné',
      viaBottom: 'Par en dessous',
      viaTop: 'Par dessus',
      technicalFeasibility: 'Faisabilité Technique',
      informationOnCurrentSetup: 'Informations sur la configuration actuelle',
      productPackaging: 'Packaging produit',
      pumpType: 'Type de pompe',
      rentalPumpRequired: 'Pompe de location requise pour l\'essai?',
      linesTwentyFive: 'Conduites côté aspiration ≥ DN20',
      linesFifteen: 'Conduites côté pression > DN15',
      valves: 'Vannes/Raccords avec ouvertures de passage > DN15',
      riskExposure: 'Risque d\'exposition au produit < 5°C',
      productUsedBefore: 'Produit utilisé auparavant',
      tankBottom: 'Fond du réservoir',
      productRecirculation: 'Recirculation du produit',
      productWithdrawel: 'Soutirage produit',
      numberOfFtl: 'Nombre de camions complets par an',
      timeBetweenDeliveries: 'Temps entre livraisons (j)',
      potatoSegment: 'Pomme de terre / Purée',
      noSubSegment: 'Pas de sous-catégorie',
      metal: 'métaux',
      fiveYearsDisclaimer: 'Tableau à titre indicatif qui ne tient pas compte de la rotation des cultures.',
      'cookie.consent': 'Nous utilisons des cookies pour améliorer l\'expérience utilisateur. En utilisant notre site web, vous acceptez l\'utilisation de cookies.',
      'cookie.learnMore': 'En savoir plus',
      'cookie.acceptAll': 'Tout accepter',
      'cookie.onlyNecessary': 'Uniquement nécessaires',
      'cookie.decline': 'Refuser',
      CAPoptimal: 'CAP minimum',
      advancedMode: 'Expert',
      easyVersion: 'Essentiel',
      in: 'en',
    },
  },

  Hungarian: {
    translation: {
      noOptions: 'No options!',
      search: 'Search...',
      strategy: 'Strategy',
      welcomeToEvs: 'Welcome to Omya App',
      signInAsOmyaUser: 'Sign in as Omya User',
      or: 'OR',
      to: 'la',
      from: 'tól től',
      signInAsDistributor: 'Sign in as Distributor',
      signInWithCredentials: 'Bejelentkezés hitelesítő adatokkal',
      continueWithSSO: 'Folytatás Single Sign-On (SSO) szolgáltatással',
      signinwithMocrosoft: 'Sign in with Microsoft',
      multifactorAuthentication: 'Multi-factor Authentication',
      phoneNumber: 'Phone number',
      confirmationPhoneCodeMessage: 'We sent an SMS with a confirmation code to the number',
      confirmationEmailCodeMessage: 'We send a message to {{email}} with a confirmation code to change your phone number',
      scanQr: 'Scan this QR Code in -app to verify device',
      enterManually: 'Or enter the code manually',
      code: 'Code',
      continue: 'Continue',
      linkExpired: 'The link has expired',
      sendMessageTo: 'Please send a message to',
      toGetLink: 'to get a new login link',
      email: 'Email',
      password: 'Password',
      fieldRequired: 'This field is required',
      signIn: 'Sign in',
      enterPasswordFor: 'Please enter the password',
      for: 'for',
      confirmPassword: 'Confirm Password',
      confirm: 'Confirm',
      passwordDoesNotMatch: 'Password does not match',
      help: 'Help Desk',
      helpQuestion:
        'If you have any questions or suggestions, you can ask them here',
      chooseCategory: 'Choose category',
      category: 'Category',
      message: 'Message',
      typeMessage: 'Type your message here',
      attachFile: 'Attach file',
      sendFeedback: 'Send Feedback',
      messageSucces: 'Your message has been sent successfully',
      success: 'Success',
      goBack: 'Go back',
      bugsErrors: 'Bugs & Errors',
      feedback: 'Feedback',
      prospectMap: 'Prospect Map',
      prospectMapText: 'Locate nearby prospects with ease',
      industryBrief: 'Industry/Application Brief',
      industryBriefText: 'Get quickly a 1 pager an industry/application brief',
      converter: 'Product Converter',
      converterText: 'Find Omya alternatives for your used products',
      feasibility: 'Feasibility Check',
      feasibilityText: 'Feasibility check of prospect\'s operation',
      finder: 'Product Finder',
      finderText: 'Find the closer product',
      croptimizer: 'CrOptimizer',
      croptimizerText:
        'Döntéshozatalt támogató kalkulátor meszezésben és talajjavításbann',
      home: 'Home',
      currentProductTitle: 'Current product used by customer',
      selectValue: 'Select value',
      currentAlkali: 'Current Alkali',
      concentration: 'Concentration',
      annualConsumption: 'Annual consumption',
      enterAnnualConsumption: 'Enter annual consumption',
      price: 'Ár',
      enterPrice: 'Adja meg az árat',
      currentExpenditure: 'Current annual expenditure',
      year: 'year',
      omyaOffered: 'Omya product offered to customer',
      product: 'Termék',
      costDelivered: 'Product Cost Delivered',
      comparison: 'Comparison',
      ton: 'ton',
      omyaProduct: 'Omya product name',
      expectedConsumption: 'Expected product consumption',
      productCost: 'Annual product cost',
      savings: 'Annual savings',
      relativeSavings: 'Relative savings',
      back: 'Vissza',
      save: 'Save',
      cancel: 'Cancel',
      confirmation: 'Confirmation',
      unsavedChanges:
        'You have unsaved changes. Are you sure you want to close this page?',
      blue: 'Blue',
      blueLight: 'Blue light',
      green: 'Green',
      app: 'App',
      language: 'Language',
      currency: 'Currency',
      adminPanel: 'Admin Panel',
      profile: 'Profile',
      companyName: 'Company name',
      enterCompanyName: 'Enter company name',
      industry: 'Industry',
      industrySubSegment: 'Industry sub-segment',
      applications: 'Applications',
      products: 'Products',
      skipToBrief: 'Skip to Brief',
      calculateIntoBrief: 'Calculate into Brief',
      chooseProspect: 'Choose prospects',
      contact: 'Contact',
      contactNumber: 'Contact number',
      status: 'Status',
      rating: 'Rating',
      edit: 'Edit',
      latitude: 'Latitude',
      longtitude: 'Longtitude',
      board: 'Board',
      supplyPlan: 'Supply Plan',
      synthesis: 'Synthesis',
      download: 'Letöltés',
      currentStatus: 'Jelenlegi állapot',
      targetStatus: 'Célállapot',
      resetData: 'Adatok visszaállítása',
      addProductFigures: 'Add product figures',
      generateBrief: ' Generate Brief',
      next: 'Következő',
      soil: 'Talaj',
      crop: 'Növény',
      potentialProductivityGain: 'Potenciális termelékenység növekedés',
      economicProductivityGain: 'Gazdasági haszon / termelékenység',
      fertilization: 'Műtrágyázás',
      productName: 'Termék neve',
      cropType: 'Növénytípus',
      yieldGain: 'Hozamnövekedés',
      additionalParams: 'Beállítható paraméterek',
      mineralizationGain: 'Ásványosodási nyereség',
      whatIsStrategyFiveYears: 'Mi a stratégiája a következő 5 évre?',
      potentialLossesFiveYears:
        'Potenciális veszteség 5 év alatt, pH-javulás nélkül',
      potentialLossesMain:
        'Potenciális veszteség 5 év alatt, pH-fenntartás nélkül',
      total: 'ÖSSZ.',
      cost: 'Költségek',
      potentialProfitFiveYears:
        'Potenciális nyereség 5 év alatt a pH javulásával',
      potentialProfitMain: 'Potenciális nyereség 5 év alatt pH fenntartásával',
      delete: 'Töröl',
      deleteText:
        'Biztosan törli ezt a mezőt? Ez is törlésre kerül innen Supply Plan?',
      deleteTextWithoutSupply: 'Biztosan törli ezt a mezőt?',
      farmSupplyPlan: 'Mezőgazdasági ellátási terv',
      farmName: 'Gazdaság neve és elérhetősége',
      date: 'Dátum',
      farm: 'Farm',
      fieldName: 'Tábla neve',
      cropRotationReminder: 'Emlékeztető a vetésforgóra',
      omyaSolutions: 'Omya fejlesztések',
      area: 'Terület',
      dose: 'Dózis',
      soilPh: 'Talaj pH',
      currentph: 'Jelenlegi pH',
      limingStatus: 'Technológia',
      targetph: 'Cél pH',
      totalPerField: 'ÖSSZESEN táblánként',
      perCrop: 'terményenként',
      roi: 'R.O.I.',
      supplyandcrop: 'Supply Plan & CropRotation',
      supplyDelete: 'Tól Supply Plan',
      whereWouldYouLikeDelete: 'Hol szeretné törölni a mező adatait?',
      noFieldsTable:
        'Még nem adtak hozzá mezőt a mezőgazdasági ellátási tervhez.',
      synthesisTableEmpty:
        'Kérjük, először adja hozzá a Fileds-t a mezőgazdasági ellátási tervhez, hogy itt megtekinthesse az összesített adatokat.',
      goodReasons:
        'Jó ok arra, hogy a talajokat az Omya fejlesztéseit alkalmazza',
      doseTooltip:
        'Javító vagy fenntartó dózis a vetésforgó során (2-5 kultúra).',
      roiTooltip:
        'A potenciális nyereség vagy potenciális R.O.I. (Return On Investment) tájékoztató jellegű, mivel a helyi talaj- és éghajlati viszonyok növelhetik vagy csökkenthetik ezeket az értékeket.',
      current: 'Jelenlegi',
      target: 'Cél',
      name: 'Név',
      productDescription: 'Product description',
      productFigures: 'Product figures',
      keyAdv: 'Key advantages',
      implementationExample: 'Implementation example',
      donwloadPdf: 'Letöltés pdf',
      addCrop: 'Vágás hozzáadása',
      cropRotation: 'Crop Rotation',
      yield: 'Hozam',
      phNolimeapp: 'pH meszezés nélkül',
      expect: 'Várható',
      yieldGains: 'Hozamnövekedés',
      npkFertilizerdecrease: 'NPK műtrágya inputok',
      totalGains: 'Teljes nyereség',
      add: 'Hozzáadás',
      enterFieldName: 'Írja be a mező nevét',
      namefieldunique: 'A mező nevének egyedinek kell lennie',
      surface: 'Felület',
      phavgAnnualDecrease: 'pH átlagos éves csökkenése',
      soilType: 'Talajtípus',
      fineDrySoil: 'Művelési mélység',
      fieldTotalCropRotation: 'ÖSSZES szántó területe a vetésforgóban',
      gains: 'Nyereség',
      organicMatter: 'Szerves anyag',
      om: 'OM',
      npkPrices: 'NPK-árak',
      editCrop: 'Vágás szerkesztése',
      npk: 'NPK',
      monps: 'OM-NPS',
      fieldAddedToSupply: 'Ez a mező hozzáadásra került a Supply Plan',
      duplicatedField: 'Ismétlődő mező',
      deleteField: 'Mező törlése',
      addToSupply: 'Hozzáadás Supply Plan',
      updateSupply: 'Frissítés be Supply Plan',
      field: 'Terület',
      addField: 'Mező hozzáadása',
      twototen: '2-10 tenyészet',
      rdtnpks: 'Hozam+NPKS',
      systemofUnits: 'System of units',
      productFinder: 'Product Finder',
      filters: 'Filters',
      brand: 'Brand',
      application: 'Application',
      transport: 'Transport',
      particleSize: 'Particle size',
      prodClass: 'Prod. Class',
      solidContent: 'Solid Content',
      ginIndex: 'GIN index',
      plant: 'Plant',
      plantCity: 'Plant City',
      currentYield: 'Aktuális hozam',
      pricePerTon: 'Tonnánkénti ár',
      npkInput: 'NPK-bevitel',
      expectedNpkGains: 'Várható NPK nyereség',
      npkEffiCurrentPh: 'NPK hatékonyság / jelenlegi pH',
      npkEffiTarget: 'NPK hatékonyságnövekedés / cél-pH',
      npkEffiGain: 'NPK hatékonyságnövekedés',
      totalNpkGain: 'ÖSSZES NPK nyereség',
      soilPhEvolution: 'A pH-értékének alakulása',
      yieldLosses: 'Terméskiesés',
      npkLosses: 'NPK veszteségek',
      lossesmonps: 'Veszteség / OM-NPS',
      soilPhachieved: 'Az elért talaj pH',
      npkGains: 'NPK nyereség',
      gainsmonps: 'Nyereség / OM-NPS',
      improvementincost: 'A költségek javulása',
      returnoninvestment: 'A beruházás megtérülése',
      returnoninvestmentFor: '',
      minimumPossibleValue: 'Minimális lehetséges érték',
      maximumPossibleValue: 'Maximális lehetséges érték',
      phAvgAnnualDecrease: 'pH átlagos éves csökkenése',
      capIndex: 'CAP hatékonyság',
      soilTillage: 'Talajművelés',
      soiltooltip1: '0% = talajművelés nélkül',
      soiltooltip2: '50% = 1 szántás + 2 talajművelési menet',
      monthYear: 'Hónapok / év',
      atCurrentPh: 'nál Jelenlegi pH',
      atTargetPh: 'nál Cél pH',
      fineDryTooltip1:
        'Felszín x talajművelési mélység x talajsűrűség x % finom talaj < 2 mm.',
      example: 'Példa',
      improvementSoilPh: 'A pH-érték javulás az Omya Megoldások hatására',
      maintainingSoilPh: 'Talaj pH fenntartása Omya Megoldásokkal',
      service: 'Szolgáltatás',
      splitInYear: 'Megosztás(év)',
      frequency: 'Gyakoriság',
      carbonateAgronomic: 'Carbonate Agronomic Performance',
      optimum: 'Optimális',
      selected: 'Kiválasztott',
      efficiency: 'Hatékonyság',
      highPotential: 'High potential',
      somePotential: 'Some potential',
      noPotential: 'No potential',
      improving: 'Javítás',
      maintanence: 'Fenntartás',
      yr: 'év',
      distributor: 'Distributor',
      surfaceArea: 'Tábla mérete',
      feasibilityCheck: 'Feasibility Check',
      economic: 'Economic',
      plantSetUp: 'Plant Set-up',
      chemical: 'Chemical',
      technical: 'Technical',
      report: 'Report',
      specify: 'Specify',
      logout: 'Log out',
      deleteAccount: 'Delete an account',
      accountDeletedSuccess: 'Account deleted successfully',
      privacyPolicy: 'Privacy Policy',
      termsOfUse: 'Terms of Use',
      confirmDelete: 'Are you sure that you want to delete your account?',
      productDose: 'A termék adagja NV (CaO)',
      productCost1: 'Termékköltség',
      cropYieldGain: 'Terméshozamnövekedés',
      nameError: 'Töltse ki a mező nevét felülről',
      modify: 'Módosít',
      duplicate: 'Másolat',
      totalLosses: 'Összes veszteség',
      synthesis1:
        'Az Omya meszezőanyagai lazítják a talajt, csökkenti az energiaköltségeket és a szerszámok kopását.',
      synthesis2:
        'Az Omya termékek serkentik a talaj termékenységéhez és a növények egészséges növekedéséhez szükséges hasznos biomasszát.',
      synthesis3:
        'Az Omya meszezőanyagai javítják a talaj vízmegtartását és hozzáférhetőségét a növények számára',
      synthesis4:
        'Az Omya termékek támogatják a növények egészségét és a bio-agensekkel szembeni ellenállóképességet',
      synthesis5:
        'Az Omya meszezőanyagai javítják a növények termőképességét és minőségét',
      synthesis6:
        'Az Omya meszezés csökkenti a környezeti lábnyomot, miközben növeli a nyereséget',
      years: 'év',
      nv: 'SE',
      soilPriceDisable: 'Kérjük, adja meg a termék árát',
      maintained: 'Karbantartott',
      gain: 'nyereség',
      forPhIncreasing: 'a pH-tól növekvő',
      disclaimer: 'KIZÁRÓLAGOSSÁGI FELTÉTEL',
      disclaimerText:
        'A programban található minden információ jóhiszeműen kerül rendelkezésre bocsátásra, de nem vállalunk sem kifejezett, sem hallgatólagos garanciát a programban található információk pontosságára, megfelelőségére, érvényességére, megbízhatóságára, hozzáférhetőségére vagy teljességére vonatkozóan. Az omya semmilyen körülmények között nem vállal felelősséget semmilyen veszteségért vagy kárért, amely a program használatából vagy a programban található bármely információra való hagyatkozásból ered. A program használata és az információkra való hagyatkozás kizárólag az ügyfél saját felelősségére történik. A program, beleértve annak megjelenítését is, az Omya tulajdonát képezi, szerzői és egyéb szellemi tulajdonjogok által védett, és korlátlan ideig titoktartási kötelezettség alá esik. Tilos a nyilvánosságra hozatal, másolás vagy visszafejtés. A programból származó információk kizárólag általános tájékoztatás céljából kerülnek rendelkezésre bocsátásra.',
      warning: 'FIGYELMEZTETÉS Az',
      warningText:
        'A program műszaki és gazdasági eredményei (szimulációk) a felhasználó által megadott információk alapján készülnek. A felhasználó által megadott információk a programban szereplő matematikai modellek kiindulási adatai. A programban szereplő matematikai modellek a potenciális műszaki és gazdasági előnyök átlagos nagyságrendjét adják meg. A terepen elért tényleges eredmény a helyi talaj- alamint éghajlati viszonyoktól és a gazdálkodó tényleges gyakorlatától függ. ',
      maintenance: 'Fenntartás',
      yes: 'Igen',
      no: 'Nem',
      no_1: 'Nem',
      fiveYearsDisclaimer: 'Tájékoztató jellegű táblázat, amely nem veszi figyelembe a vetésforgót.',
      'cookie.consent': 'A weboldalunk használatával elfogadja a sütik használatát.',
      'cookie.learnMore': 'További információ',
      'cookie.acceptAll': 'Összes elfogadása',
      'cookie.onlyNecessary': 'Csak a szükségesek',
      'cookie.decline': 'Elutasítás',
      CAPoptimal: 'Optimális CAP',
      advancedMode: 'Szakértő',
      easyVersion: 'Alapok',
      in: 'in',
    },
  },

  Romanian: {
    translation: {
      noOptions: 'No options!',
      search: 'Search...',
      strategy: 'Strategy',
      welcomeToEvs: 'Welcome to Omya App',
      signInAsOmyaUser: 'Sign in as Omya User',
      or: 'OR',
      to: '-',
      from: 'din',
      signInAsDistributor: 'Sign in as Distributor',
      signInWithCredentials: 'Sign in with Credentials',
      continueWithSSO: 'Continue with Single Sign-On (SSO)',
      signinwithMocrosoft: 'Sign in with Microsoft',
      multifactorAuthentication: 'Multi-factor Authentication',
      phoneNumber: 'Phone number',
      confirmationPhoneCodeMessage: 'We sent an SMS with a confirmation code to the number',
      confirmationEmailCodeMessage: 'We send a message to {{email}} with a confirmation code to change your phone number',
      scanQr: 'Scan this QR Code in -app to verify device',
      enterManually: 'Or enter the code manually',
      code: 'Code',
      continue: 'Continue',
      linkExpired: 'The link has expired',
      sendMessageTo: 'Please send a message to',
      toGetLink: 'to get a new login link',
      email: 'Email',
      password: 'Password',
      fieldRequired: 'This field is required',
      signIn: 'Sign in',
      enterPasswordFor: 'Please enter the password',
      for: 'for',
      confirmPassword: 'Confirm Password',
      confirm: 'Confirm',
      passwordDoesNotMatch: 'Password does not match',
      help: 'Help Desk',
      helpQuestion:
        'If you have any questions or suggestions, you can ask them here',
      chooseCategory: 'Choose category',
      category: 'Category',
      message: 'Message',
      typeMessage: 'Type your message here',
      attachFile: 'Attach file',
      sendFeedback: 'Send Feedback',
      messageSucces: 'Your message has been sent successfully',
      success: 'Success',
      goBack: 'Go back',
      bugsErrors: 'Bugs & Errors',
      feedback: 'Feedback',
      prospectMap: 'Prospect Map',
      prospectMapText: 'Locate nearby prospects with ease',
      industryBrief: 'Industry/Application Brief',
      industryBriefText: 'Get quickly a 1 pager an industry/application brief',
      converter: 'Product Converter',
      converterText: 'Find Omya alternatives for your used products',
      feasibility: 'Feasibility Check',
      feasibilityText: 'Feasibility check of prospect\'s operation',
      finder: 'Product Finder',
      finderText: 'Find the closer product',
      croptimizer: 'CrOptimizer',
      croptimizerText:
        'Aplicaţie pentru recomandarea fertilizanţilor cu calciu',
      home: 'Home',
      currentProductTitle: 'Current product used by customer',
      selectValue: 'Select value',
      currentAlkali: 'Current Alkali',
      concentration: 'Concentration',
      annualConsumption: 'Annual consumption',
      enterAnnualConsumption: 'Enter annual consumption',
      price: 'Preț',
      enterPrice: 'Introduceți prețul',
      currentExpenditure: 'Current annual expenditure',
      year: 'year',
      omyaOffered: 'Omya product offered to customer',
      product: 'Produs',
      costDelivered: 'Product Cost Delivered',
      comparison: 'Comparison',
      ton: 'ton',
      omyaProduct: 'Omya product name',
      expectedConsumption: 'Expected product consumption',
      productCost: 'Annual product cost',
      savings: 'Annual savings',
      relativeSavings: 'Relative savings',
      back: 'Înapoi',
      save: 'Save',
      cancel: 'Cancel',
      confirmation: 'Confirmation',
      unsavedChanges:
        'You have unsaved changes. Are you sure you want to close this page?',
      blue: 'Blue',
      blueLight: 'Blue light',
      green: 'Green',
      app: 'App',
      language: 'Language',
      currency: 'Currency',
      adminPanel: 'Admin Panel',
      profile: 'Profile',
      companyName: 'Company name',
      enterCompanyName: 'Enter company name',
      industry: 'Industry',
      industrySubSegment: 'Industry sub-segment',
      applications: 'Applications',
      products: 'Products',
      skipToBrief: 'Skip to Brief',
      calculateIntoBrief: 'Calculate into Brief',
      chooseProspect: 'Choose prospects',
      contact: 'Contact',
      contactNumber: 'Contact number',
      status: 'Status',
      rating: 'Rating',
      edit: 'Edit',
      latitude: 'Latitude',
      longtitude: 'Longtitude',
      board: 'Board',
      supplyPlan: 'Supply Plan',
      synthesis: 'Synthesis',
      download: 'Descarca',
      currentStatus: 'pH-ul actual',
      targetStatus: 'pH-ul țintă',
      resetData: 'Resetați datele',
      addProductFigures: 'Add product figures',
      generateBrief: ' Generate Brief',
      next: 'Următorul',
      soil: 'Solul',
      crop: 'Cultură',
      potentialProductivityGain: 'Creștere potențială de producție',
      economicProductivityGain: 'Câștig economic / productivitate',
      fertilization: 'Fertilizare',
      productName: 'Denumirea produsului',
      cropType: 'Tipul de cultură',
      yieldGain: 'Câștig de producție',
      additionalParams: 'Parametrii ajustabili',
      mineralizationGain: 'Câștig de mineralizare',
      whatIsStrategyFiveYears:
        'Care este strategia dumneavoastră pentru următorii 5 ani?',
      potentialLossesFiveYears:
        'Pierderi potențiale în 5 ani fără corecția pH-ului',
      potentialLossesMain:
        'Pierderi potențiale pe o perioadă de 5 ani fără întreținere a pH-ului',
      total: 'Total',
      cost: 'Cost',
      potentialProfitFiveYears:
        'Profituri potențiale pe 5 ani cu corecția pH-ului',
      potentialProfitMain:
        'Profituri potențiale pe 5 ani cu întreținerea pH-ului',
      delete: 'Șterge',
      deleteText:
        'Sigur doriți să ștergeți acest câmp? De asemenea, va fi șters din Supply Plan',
      deleteTextWithoutSupply: 'Sigur doriți să ștergeți acest câmp?',
      farmSupplyPlan: 'Planul de aprovizionare a fermei',
      farmName: 'Numele fermei și persoana de contact',
      date: 'Data',
      farm: 'Fermă',
      fieldName: 'Parcelă ',
      cropRotationReminder: 'Reamintire privind rotația culturilor',
      omyaSolutions: 'Soluțiile Omya',
      area: 'Zona',
      dose: 'Doza',
      soilPh: 'pH-ul solului',
      currentph: 'pH-ul actual',
      limingStatus: 'Tip ameliorare',
      targetph: 'pH-ul țintă',
      totalPerField: 'TOTAL pe câmp',
      perCrop: 'per cultură',
      roi: 'R.O.I.',
      supplyandcrop: 'Supply Plan & CropRotation',
      supplyDelete: 'Din Supply Plan',
      whereWouldYouLikeDelete:
        'Unde doriți să ștergeți datele despre acest câmp?',
      noFieldsTable:
        'Niciun câmp nu a fost adăugat încă la Planul de aprovizionare cu fermă',
      synthesisTableEmpty:
        'Vă rugăm să adăugați mai întâi fișiere la Planul de aprovizionare pentru fermă pentru a putea vizualiza datele agregate aici.',
      goodReasons:
        'Motive întemeiate pentru a ameliora solurile cu Soluțiile Omya',
      doseTooltip:
        'doza pentru ameliorare sau doza pentru menținere în timpul rotației culturilor (2 până la 5 culturi).',
      roiTooltip:
        'Câștigurile potențiale sau potențialul R.O.I. (Return On Investment) sunt orientative, deoarece condițiile locale de sol și climatice pot crește sau scădea aceste valori.',
      current: 'Actual',
      target: 'Ţintă',
      name: 'Nume',
      productDescription: 'Product description',
      productFigures: 'Product figures',
      keyAdv: 'Key advantages',
      implementationExample: 'Implementation example',
      donwloadPdf: 'Descărcați pdf',
      addCrop: 'Adăugați cultură',
      cropRotation: 'Crop Rotation',
      yield: 'Producție',
      phNolimeapp: 'pH fără corecție',
      expect: 'Corectat',
      yieldGains: 'Plus de producție',
      npkFertilizerdecrease: 'Îngrășăminte NPK',
      totalGains: 'Total Câștiguri',
      add: 'Adăuga',
      enterFieldName: 'Introduceți numele câmpului',
      namefieldunique: 'Numele câmpului trebuie să fie unic',
      surface: 'Suprafața',
      phavgAnnualDecrease: 'Scădere anuală pH',
      soilType: 'Tipul de sol',
      fineDrySoil: 'Adâncimea de lucru',
      fieldTotalCropRotation: 'Suprafața TOTALĂ  pentru rotația culturilor',
      gains: 'Câștiguri',
      organicMatter: 'Materie organică',
      om: 'OM',
      npkPrices: 'Prețuri NPK',
      editCrop: 'EEditați cultura',
      npk: 'NPK',
      monps: 'OM-NPS',
      fieldAddedToSupply: 'Acest câmp a fost adăugat la Supply Plan',
      duplicatedField: 'Câmp duplicat',
      deleteField: 'Șterge câmpul',
      addToSupply: 'Adaugă la Supply Plan',
      updateSupply: 'Actualizați în Supply Plan',
      field: 'Camp',
      addField: 'Adăugați câmp',
      twototen: '2 până la 10 culturi',
      rdtnpks: 'Producție+NPKS',
      systemofUnits: 'System of units',
      productFinder: 'Product Finder',
      filters: 'Filters',
      brand: 'Brand',
      application: 'Application',
      transport: 'Transport',
      particleSize: 'Particle size',
      prodClass: 'Prod. Class',
      solidContent: 'Solid Content',
      ginIndex: 'GIN index',
      plant: 'Plant',
      plantCity: 'Plant City',
      currentYield: 'Randament curent',
      pricePerTon: 'Preț pe tonă',
      npkInput: 'Aport NPK',
      expectedNpkGains: 'Câștiguri NPK așteptate',
      npkEffiCurrentPh: 'Eficiența NPK / pH actual',
      npkEffiTarget: 'Câștig de eficiență NPK / pH țintă',
      npkEffiGain: 'Câștig de eficiență NPK ',
      totalNpkGain: 'Câștig TOTAL NPK',
      soilPhEvolution: 'Evoluția pH-ului solului',
      yieldLosses: 'Pierderi de producție',
      npkLosses: 'Pierderi de NPK',
      lossesmonps: 'Pierderi / OM-NPS',
      soilPhachieved: 'pH-ul solului atins',
      npkGains: 'Câștiguri NPK',
      gainsmonps: 'Câștiguri / OM-NPS',
      improvementincost: 'Eficiența costurilor în',
      returnoninvestment: 'Randamentul investițiilor',
      returnoninvestmentFor: 'pe',
      minimumPossibleValue: 'Valoarea minimă posibilă',
      maximumPossibleValue: 'Valoarea maximă posibilă',
      phAvgAnnualDecrease: 'Scădere anuală pH',
      capIndex: 'Eficiența CAP',
      soilTillage: 'Lucrarea solului',
      soiltooltip1: ' 0% = nicio lucrare a solului',
      soiltooltip2: '50% = 1 arătură + 2 treceri de prelucrare a solului',
      monthYear: 'Luni / an',
      atCurrentPh: 'la pH-ul actual',
      atTargetPh: 'la pH-ul țintă',
      fineDryTooltip1:
        'Suprafață x adâncimea de aratură x densitatea solului x % sol fin < 2 mm.',
      example: 'Exemplu',
      improvementSoilPh:
        'Creșterea pH-ului solului cu ajutorul soluțiilor Omya',
      maintainingSoilPh: 'Menținerea pH-ului solului cu soluțiile Omya',
      service: 'Serviciu',
      splitInYear: 'Aplicări',
      frequency: 'Frecvență',
      carbonateAgronomic: 'Carbonate Agronomic Performance',
      optimum: 'Optimum',
      selected: 'Selectată',
      efficiency: 'Eficiență',
      highPotential: 'High potential',
      somePotential: 'Some potential',
      noPotential: 'No potential',
      improving: 'Creșterea',
      maintanence: 'Menținere',
      yr: 'an',
      distributor: 'Distributor',
      surfaceArea: 'Suprafața parcelei',
      feasibilityCheck: 'Feasibility Check',
      economic: 'Economic',
      plantSetUp: 'Plant Set-up',
      chemical: 'Chemical',
      technical: 'Technical',
      report: 'Report',
      specify: 'Specify',
      logout: 'Log out',
      deleteAccount: 'Delete an account',
      accountDeletedSuccess: 'Account deleted successfully',
      privacyPolicy: 'Privacy Policy',
      termsOfUse: 'Terms of Use',
      confirmDelete: 'Are you sure that you want to delete your account?',
      productDose: 'Doza produsului NV (CaO)',
      productCost1: 'Costul produsului',
      cropYieldGain: 'Creșterea randamentului culturilor',
      nameError: 'Completați numele câmpului de sus',
      modify: 'Modifica',
      duplicate: 'Duplicat',
      totalLosses: 'Pierderi totale',
      synthesis1:
        'Omya Calciprill reduce costurile de energie și uzura organelor active',
      synthesis2:
        'Omya Calciprill stimulează biomasa utilă pentru fertilitatea solului și creșterea sănătoasă a plantelor',
      synthesis3:
        'Omya Calciprill îmbunătățește capacitatea de reținere și disponibilitatea apei din sol pentru plante',
      synthesis4:
        'Omya Calciprill promovează sănătatea plantelor și rezistența la bioagenți',
      synthesis5:
        'Omya Calciprill îmbunătățește producția și calitatea culturilor',
      synthesis6:
        'Omya Calciprill reduce amprenta asupra mediului, crescând în același timp profitul',
      years: 'ani',
      nv: 'NV',
      soilPriceDisable: 'Vă rugăm să introduceți prețul produsului',
      maintained: 'Menținut',
      gain: 'câștig',
      forPhIncreasing: 'pentru un pH care crește de la',
      disclaimer: 'DECLINARE DE RESPONSABILITATE',
      disclaimerText:
        'Toate informațiile din aplicaţie sunt furnizate cu bună credință, dar nu oferim nicio garanție, expresă sau implicită, cu privire la acuratețea, adecvarea, validitatea, fiabilitatea, disponibilitatea sau caracterul complet al informațiilor din aplicaţie. În nicio circumstanță omya nu va fi răspunzătoare pentru orice pierdere sau daună de orice fel survenită ca urmare a utilizării aplicaţiei sau a încrederii în orice informație furnizată. Utilizarea aplicaţiei și încrederea în informațiile oferite de aceasta se fac exclusiv pe riscul propriu al utilizatorului. Aplicaţia, inclusiv afișarea acesteia, este proprietatea Omya, este protejat de drepturile de autor și de alte drepturi de proprietate intelectuală și este supus confidențialității pe termen nelimitat. Nu este permisă divulgarea, copierea sau ingineria inversă. Informațiile care rezultă din aplicaţie sunt furnizate doar în scopuri de informare generală.',
      warning: 'AVERTISMENT',
      warningText:
        'Rezultatele tehnice și economice (simulări) ale aplicaţiei sunt generate pe baza informațiilor introduse de utilizator. Informațiile introduse de utilizator reprezintă datele inițiale pentru modelele matematice din aplicaţie. Modelele matematice din aplicaţie oferă un rezultat mediu al potențialelor beneficii tehnice și economice. Rezultatele efective obținute pe teren depind de condițiile locale de sol și climă și de practicile fermierului.',
      maintenance: 'Menținere',
      yes: 'Da',
      no: 'Nu',
      no_1: 'Nu',
      fiveYearsDisclaimer: 'Tabel cu titlu informativ, nu s-a luat în considerare rotația culturilor',
      'cookie.consent': 'Utilizăm cookie-uri pentru a îmbunătăți experiența utilizatorului. Prin utilizarea site-ului nostru web, sunteți de acord cu utilizarea cookie-urilor.',
      'cookie.learnMore': 'Mai multe informații',
      'cookie.acceptAll': 'Toate acceptate',
      'cookie.onlyNecessary': 'Doar necesare',
      'cookie.decline': 'Respinge',
      CAPoptimal: 'CAP Optim',
      advancedMode: 'Expert',
      easyVersion: 'Elemente de bază',
      in: 'în',
    },
  },
};

export default localization;
